<div class="advanced-filter-inputs-toggle-chip">
  @if (mode() === 'button') {
    <button mat-stroked-button class="v-middle" [matMenuTriggerFor]="fieldsDropdownItems">
      <mat-icon>add</mat-icon>
      {{ 'button.addFilter' | translate }}
    </button>
  } @else {
    <div
      class="advanced-filter-inputs-chip px-2 w-100"
      (mouseover)="hoveredFilterIdentityUpdate.emit(selectedFilterIdentity)"
      (mouseleave)="hoveredFilterIdentityUpdate.emit(null)"
    >
      <advanced-filter-inputs
        [dataForWidgetSpecificConfiguration]="null"
        [inputsConfiguration]="{
          type: 'add',
          mode: EAdvancedFilterInputMode.autoSubmitWithCancel,
          isEqAllowed: false,
          initialField: initialField(),
        }"
        [(selectedFilterIdentity)]="selectedFilterIdentity"
        (deleteClick)="dismissAdd(true)"
        (autoSubmit)="submit($event)"
        (dismissClick)="convertToChip()"
      ></advanced-filter-inputs>
    </div>
  }

  @if (lastAutosubmit.isValid && mode() === 'dropdowns') {
    <button mat-stroked-button class="v-middle" [style]="{ width: '150px' }" [matMenuTriggerFor]="fieldsDropdownItems">
      <mat-icon>add</mat-icon>
      {{ 'button.addFilter' | translate }}
    </button>
  }
</div>

<mat-menu class="mt-2" #fieldsDropdownItems="matMenu">
  @if (workspaceModules()?.oeeTracker) {
    <button mat-menu-item [matMenuTriggerFor]="oeeTrackerSubmenu">
      {{ workspaceModuleService.moduleNames.oeeTracker }}
    </button>
  }

  @if (workspaceModules()?.actionTracker) {
    <button mat-menu-item [matMenuTriggerFor]="actionTrackerSubmenu">
      {{ workspaceModuleService.moduleNames.actionTracker }}
    </button>
  }

  @if (fieldMenuOptions().custom.length) {
    <button mat-menu-item [matMenuTriggerFor]="customSubmenu">
      {{ 'field.customFilterMenu' | translate }}
    </button>
  }

  @for (field of fieldMenuOptions().independent; track field.id) {
    <button mat-menu-item (click)="initializeAdd(field.id)">
      {{ field.name }}
    </button>
  }
</mat-menu>

<mat-menu class="mt-2" #oeeTrackerSubmenu="matMenu">
  @for (field of fieldMenuOptions().oeeTracker; track field.id) {
    <button mat-menu-item (click)="initializeAdd(field.id)">
      {{ field.name }}
    </button>
  }
</mat-menu>

<mat-menu class="mt-2" #actionTrackerSubmenu="matMenu">
  @for (field of fieldMenuOptions().actionTracker; track field.id) {
    <button mat-menu-item (click)="initializeAdd(field.id)">
      {{ field.name }}
    </button>
  }
</mat-menu>

<mat-menu class="mt-2" #customSubmenu="matMenu">
  @for (field of fieldMenuOptions().custom; track field.id) {
    <button mat-menu-item (click)="initializeAdd(field.id)">
      {{ field.name }}
    </button>
  }
</mat-menu>
